export default __webpack_public_path__ + "e170f8f7ba79e3d1812eca32f82580b9.svg";